import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const MediaGalleryModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "MediaGalleryModalContainer" */
      './MediaGalleryModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
